import PropTypes from 'prop-types';

export const valuesShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.any.isRequired,
  active: PropTypes.bool,
});
